// extracted by mini-css-extract-plugin
export default {"table":"MergeFieldsStep_table__O3COH","fieldCol":"MergeFieldsStep_fieldCol__27MJp","choice":"MergeFieldsStep_choice__JMsPo","choiceSelected":"MergeFieldsStep_choiceSelected__fa4UM"};